export default function Marquee({ text = "CLOSE MORE, CHASE LESS", separator = "," }) {
  const item = (
    <span className="font-display text-[13vw] md:text-[9vw] font-medium tracking-tighter leading-none text-[#0a0a0a] px-8">
      {text} <span className="text-[#d4d4d4] px-4">{separator}</span>
    </span>
  );
  return (
    <div className="w-full overflow-hidden py-4 select-none" data-testid="brand-marquee">
      <div className="marquee-track">
        {item}{item}{item}{item}
      </div>
    </div>
  );
}
